import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CollectiveProvider, useIsCollectiveMode, useCollective } from './context/CollectiveContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MailerShowcase from './components/MailerShowcase';
import HowItWorks from './components/HowItWorks';
import WhyMailWorks from './components/WhyMailWorks';
import ReserveSpot from './components/ReserveSpot';
import AboutSean from './components/AboutSean';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CityPage from './pages/CityPage';
import CollectivePage from './pages/CollectivePage';
import Directory from './pages/Directory';
import Websites from './pages/Websites';
import Admin from './pages/Admin';

function HomePage() {
  return (
    <>
      <Hero />
      <MailerShowcase />
      <HowItWorks />
      <WhyMailWorks />
      <ReserveSpot citySlug="surprise" />
      <AboutSean />
      <Pricing />
      <Contact />
    </>
  );
}

function AppRoutes() {
  const isCollectiveMode = useIsCollectiveMode();

  if (isCollectiveMode) {
    // Dedicated domain — only show the one collective, block all other routes
    return (
      <Routes>
        <Route path="/" element={<CollectivePage />} />
        <Route path="/directory" element={<Directory />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  // Main mailboxflyers site — full routing
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/websites" element={<Websites />} />
      <Route path="/:citySlug/directory" element={<Directory />} />
      <Route path="/:citySlug" element={<CityPage />} />
    </Routes>
  );
}

function App() {
  return (
    <CollectiveProvider>
      <HashRouter>
        <div className="min-h-screen flex flex-col selection:bg-yellow-200 selection:text-slate-900">
          <Navbar />
          <main className="flex-grow">
            <AppRoutes />
          </main>
          <Footer />
        </div>
      </HashRouter>
    </CollectiveProvider>
  );
}

export default App;
